"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ehrForm = exports.freeform = exports.loadingAvailableLocsError = exports.loadingAvailableLocs = exports.failedGxV1 = exports.passedGx = exports.apptInfoComplete = exports.oswApptInfo = exports.checkingIsOSWEnabled = exports.pendingEhrPatientDemographics = exports.deepLinkingTimeSlotUnavailableError = exports.deepLinking = exports.checkingCaptchaSession = exports.verifyingCaptchaError = exports.verifyingCaptcha = exports.checkingIfCaptchaIsVerified = exports.didBook = exports.apptSummary = exports.apptUnavailable = exports.bookingAppt = exports.reviewAppt = exports.patientInfo = exports.apptTime = exports.apptInfo = exports.initializing = exports.pending = exports.jumpToDate = exports.newSearch = exports.nextSearch = exports.validationError = exports.verifyingPatientRegForm = exports.fetchingPatientRegForm = exports.dataEntry = exports.done = exports.redirecting = exports.error = exports.noResults = exports.success = exports.hasSeenBefore = exports.loading = exports.loadingProvider = exports.apptGxV2Questions = exports.apptGxQuestions = exports.gxQuestions = exports.apptQuestions = exports.apptPurpose = exports.noAvailability = exports.routing = exports.apptPatientRel = exports.idle = void 0;
exports.careTeamProviders = exports.altProviders = exports.joinWaitlist = exports.noSuggestedProviders = exports.suggestedProviders = exports.fetchingAltProviders = exports.bookingDisabled = exports.deepLinkedPurposeAndPendingEhrPatientDemographics = exports.deepLinkedPurpose = exports.getConditionalGxStepByProviderIdError = exports.conditionalApptGxV2Questions = exports.conditionalGxQuestions = exports.ehrSomebodyElseFormRelatedFailed = exports.ehrSomebodyElseForm = exports.patientForm = exports.ehrData = exports.ehrSubFailed = exports.ehrFormRelatedFailed = exports.ehrMainFailed = exports.ehrFormNoDropdown = void 0;
exports.idle = '@state/IDLE';
exports.apptPatientRel = '@state/APPT_PATIENT_REL';
exports.routing = '@state/ROUTING';
exports.noAvailability = '@state/NO_AVAILABILITY';
exports.apptPurpose = '@state/APPT_PURPOSE';
exports.apptQuestions = '@state/APPT_QUESTIONS';
exports.gxQuestions = '@state/GX_QUESTIONS';
exports.apptGxQuestions = '@state/APPT_GX_QUESTIONS';
exports.apptGxV2Questions = '@state/APPT_GX_V2_QUESTIONS';
exports.loadingProvider = '@state/LOADING_PROVIDER';
exports.loading = '@state/LOADING';
exports.hasSeenBefore = '@state/HAS_SEEN_BEFORE';
exports.success = '@state/SUCCESS';
exports.noResults = '@state/NO_RESULTS';
exports.error = '@state/ERROR';
exports.redirecting = '@state/REDIRECTING';
exports.done = '@state/DONE';
exports.dataEntry = '@state/DATA_ENTRY';
exports.fetchingPatientRegForm = '@state/FETCHING_PATIENT_REG_FORM';
exports.verifyingPatientRegForm = '@state/VERIFYING_PATIENT_REG_FORM';
exports.validationError = '@state/VALIDATION_ERROR';
exports.nextSearch = '@state/NEXT_SEARCH';
exports.newSearch = '@state/INITIAL_LOAD';
exports.jumpToDate = '@state/JUMP_TO_DATE';
exports.pending = '@state/PENDING';
exports.initializing = '@state/INITIALIZING';
exports.apptInfo = '@state/APPT_INFO';
exports.apptTime = '@state/APPT_TIME';
exports.patientInfo = '@state/PATIENT_INFO';
exports.reviewAppt = '@state/REVIEW_APPT';
exports.bookingAppt = '@state/BOOKING_APPT';
exports.apptUnavailable = '@state/APPT_UNAVAILABLE';
exports.apptSummary = '@state/APPT_SUMMARY';
exports.didBook = '@state/DID_BOOK';
exports.checkingIfCaptchaIsVerified = '@state/CHECKING_IF_CAPTCHA_IS_VERIFIED';
exports.verifyingCaptcha = '@state/VERIFYING_CAPTCHA';
exports.verifyingCaptchaError = '@state/VERIFYING_CAPTCHA_ERROR';
exports.checkingCaptchaSession = '@state/CHECKING_CAPTCHA_SESSION';
exports.deepLinking = '@state/DEEP_LINKING_PATIENT_REL_AND_PURPOSE';
exports.deepLinkingTimeSlotUnavailableError = '@state/DEEP_LINKING_TIME_SLOT_UNAVAILABLE_ERROR';
exports.pendingEhrPatientDemographics = '@state/GETTING_EHR_PATIENT_DEMOGRAPHICS';
exports.checkingIsOSWEnabled = '@state/CHECKING_IS_OSW_ENABLED';
exports.oswApptInfo = '@state/OSW_APPT_INFO';
exports.apptInfoComplete = '@state/APPT_INFO_COMPLETE';
exports.passedGx = '@state/PASSED_GX';
exports.failedGxV1 = '@state/FAILED_GX_V1';
exports.loadingAvailableLocs = '@state/LOADING_AVAILABLE_LOCS';
exports.loadingAvailableLocsError = '@state/LOADING_AVAILABLE_LOCS_ERROR';
exports.freeform = '@state/FREEFORM';
exports.ehrForm = '@state/EHR_FORM';
exports.ehrFormNoDropdown = '@state/EHR_FORM_NO_DROPDOWN';
exports.ehrMainFailed = '@state/EHR_MAIN_FAILED';
exports.ehrFormRelatedFailed = '@state/EHR_FORM_RELATED_FAILED';
exports.ehrSubFailed = '@state/EHR_SUB_FAILED';
exports.ehrData = '@state/EHR_DATA';
exports.patientForm = '@state/PATIENT_FORM';
exports.ehrSomebodyElseForm = '@state/EHR_SOMEBODY_ELSE_FORM';
exports.ehrSomebodyElseFormRelatedFailed = '@state/EHR_SOMEBODY_ELSE_FORM_RELATED_FAILED';
exports.conditionalGxQuestions = '@state/CONDITIONAL_GX_QUESTIONS';
exports.conditionalApptGxV2Questions = '@state/CONDITIONAL_APPT_GX_V2_QUESTIONS';
exports.getConditionalGxStepByProviderIdError = '@state/GET_CONDITIONAL_GX_STEP_BY_PROVIDER_ID_ERROR';
exports.deepLinkedPurpose = '@state/DEEP_LINKED_PURPOSE';
exports.deepLinkedPurposeAndPendingEhrPatientDemographics = '@state/DEEP_LINKED_PURPOSE_AND_PENDING_EHR_PATIENT_DEMOGRAPHICS';
exports.bookingDisabled = '@state/BOOKING_DISABLED';
exports.fetchingAltProviders = '@state/FETCHING_ALT_PROVIDERS';
exports.suggestedProviders = '@state/SUGGESTED_PROVIDERS';
exports.noSuggestedProviders = '@state/NO_SUGGESTED_PROVIDERS';
exports.joinWaitlist = '@state/JOIN_WAITLIST';
exports.altProviders = '@state/ALT_PROVIDERS';
exports.careTeamProviders = '@state/CARE_TEAM_PROVIDERS';
//# sourceMappingURL=States.js.map